import { SchedulerConfig, SchedulerType, SchedulerCondition, SchedulerStatus } from '@repo/types';

/**
 * Check if a component or nav node should be visible based on its scheduler config.
 */
export const isComponentVisible = (
  scheduler: SchedulerConfig | undefined,
  isEnabled: boolean | undefined = undefined,
  status: SchedulerStatus | null
): boolean => {
  if (isEnabled === false) {
    return false;
  }

  if (!scheduler) {
    return true;
  }

  const now = new Date();

  switch (scheduler.type) {
    case SchedulerType.Always:
      return true;

    case SchedulerType.DateTime:
      if (!scheduler.startDate) {
        return true;
      }
      return now >= new Date(scheduler.startDate);

    case SchedulerType.Period: {
      const startDate = scheduler.startDate ? new Date(scheduler.startDate) : null;
      const endDate = scheduler.endDate ? new Date(scheduler.endDate) : null;

      if (startDate && now < startDate) {
        return false;
      }
      if (endDate && now > endDate) {
        return false;
      }
      return true;
    }

    case SchedulerType.Condition:
      return evaluateCondition(scheduler.condition, status);

    default:
      return true;
  }
};

/**
 * Evaluate a match-based condition against the currently polled scheduler status.
 */
export const evaluateCondition = (
  condition: SchedulerCondition | undefined,
  status: SchedulerStatus | null
): boolean => {
  if (!condition || !status) {
    return true;
  }

  switch (condition) {
    case SchedulerCondition.GamesForDay:
      return status.hasGamesForDay;

    case SchedulerCondition.NoGamesForDay:
      return !status.hasGamesForDay;

    case SchedulerCondition.HasLiveGame:
      return status.hasLiveGame;

    case SchedulerCondition.NoLiveGame:
      return !status.hasLiveGame;

    default:
      return true;
  }
};
